// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

const TruckDispatch2Page = lazy(
  () => import('@/features/truck/dispatch/v2/TruckDispatch2Page'),
);
const TruckStatusDetail2Page = lazy(
  () => import('@/features/truck-status-detail/v2/TruckStatusDetail2Page'),
);
const DockManager2Page = lazy(() => import('@/features/truck/dockmanager/v2/DockManager2Page'));
const ShipStation2Page = lazy(() => import('@/features/shipping/station2/ShipStation2Page'));
const CartonLookup2Page = lazy(() => import('@/features/cartons/lookup2/CartonLookup2Page'));
const ShipConsole2Page = lazy(() => import('@/features/shipping/shipping2/ShipConsole2Page'));
const TruckLoadWaving2Page = lazy(
  () => import('@/features/orders/truckloadwaving2/TruckLoadWaving2Page'),
);
const KitRun2Page = lazy(() => import('@/features/kit/run2/KitRun2Page'));
const QcInspect2Page = lazy(() => import('@/features/qc/inspect2/QcInspect2Page'));
const AdjustSearch2Page = lazy(
  () => import('@/features/inventory/adjustsearch2/AdjustSearch2Page'),
);

export const slot2Routes: ReactElement[] = [
  // rank 10 — Truck Dispatch v2 (faithful: /browse/trucks, PB w_truck_search).
  <Route
    key="/truck/dispatch2"
    path="/truck/dispatch2"
    element={
      <RequireAuth>
        <TruckDispatch2Page />
      </RequireAuth>
    }
  />,
  // rank 13 — Truck Status Detail v2 (faithful:
  // /shipping/truck-status-detail/:warehouseId/:truckId, PB w_truck_status_detail).
  // The bare route renders the status2-style lookup card so /v2-screens can always link it.
  <Route
    key="/truck/status-detail2"
    path="/truck/status-detail2"
    element={
      <RequireAuth>
        <TruckStatusDetail2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/truck/status-detail2/:warehouseId/:truckId"
    path="/truck/status-detail2/:warehouseId/:truckId"
    element={
      <RequireAuth>
        <TruckStatusDetail2Page />
      </RequireAuth>
    }
  />,
  // rank 28 — Dock Door Manager v2 (faithful: /browse/dock-manager-door,
  // PB w_dock_manager_door).
  <Route
    key="/truck/dock2"
    path="/truck/dock2"
    element={
      <RequireAuth>
        <DockManager2Page />
      </RequireAuth>
    }
  />,
  // rank 25 — Shipping Station v2 (faithful: /ship/station, PB w_ship_station +
  // uo_ship_station_support). Renders bare: an empty station IS the screen.
  <Route
    key="/ship/station2"
    path="/ship/station2"
    element={
      <RequireAuth>
        <ShipStation2Page />
      </RequireAuth>
    }
  />,
  // rank 29 — Carton Lookup v2 (faithful: /cartons/lookup, PB w_cartlook). Accepts the same
  // ?cartonId= / ?warehouseId= deep-link params the faithful page does; bare = the scan band.
  <Route
    key="/cartons/lookup2"
    path="/cartons/lookup2"
    element={
      <RequireAuth>
        <CartonLookup2Page />
      </RequireAuth>
    }
  />,
  // rank 30 — Shipping Process console v2 (faithful: /browse/ship-shipping,
  // PB w_ship_shipping).
  <Route
    key="/ship/console2"
    path="/ship/console2"
    element={
      <RequireAuth>
        <ShipConsole2Page />
      </RequireAuth>
    }
  />,
  // rank 27 — Truck Load Waving v2 (faithful: /orders/truck-load-waving, PB w_truck_sequence).
  // Takes no route params: PB's bare menu open is the whole pickable set.
  <Route
    key="/orders/truck-load-waving2"
    path="/orders/truck-load-waving2"
    element={
      <RequireAuth>
        <TruckLoadWaving2Page />
      </RequireAuth>
    }
  />,
  // rank 15 — Kit Run v2 (faithful: /kit-runs/:warehouseId/:kitRun, PB w_kit_run).
  // The bare route renders the status2-style lookup card so /v2-screens can always link it.
  <Route
    key="/kit-runs2"
    path="/kit-runs2"
    element={
      <RequireAuth>
        <KitRun2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/kit-runs2/:warehouseId/:kitRun"
    path="/kit-runs2/:warehouseId/:kitRun"
    element={
      <RequireAuth>
        <KitRun2Page />
      </RequireAuth>
    }
  />,
  // rank 44 — QC Inspect v2 (faithful: /qc/inspect, PB w_qc_check). Renders bare: the
  // Pallet/Carton scan band IS the screen's entry point.
  <Route
    key="/qc/inspect2"
    path="/qc/inspect2"
    element={
      <RequireAuth>
        <QcInspect2Page />
      </RequireAuth>
    }
  />,
  // slice-3688 — Adjust Inventory Search v2 (faithful: /browse/adjust-search, PB
  // w_adjust_search). Built for the demo "New Screens" slider (docs/demochanges.txt,
  // CHRIS 2026-09-17), not off v2_wins.html. Takes no route params: PB's bare menu open
  // IS the screen, and the four Search-For grains ride ?view=.
  <Route
    key="/browse/adjust-search2"
    path="/browse/adjust-search2"
    element={
      <RequireAuth>
        <AdjustSearch2Page />
      </RequireAuth>
    }
  />,
];
